$(document).ready(function () {
    'use strict';

    if ($('.mainMenu .sub').length) {
        $('.mainMenu > li').hoverIntent({
            sensitivity: 10,
            interval: 80,
            over: function() {
                if(windowWidth > window.breakpoints.mobile) {
                    var $this = $(this);

                    if($this.find('.sub').length && !$this.parents('.slideOutMenu').length) {
                        $this.addClass('showSub');
                        $('.sub', this).stop(true, true).fadeIn(300);
                    }
                }
            },
            //timeout: 150,
            out: function() {
                if(windowWidth > window.breakpoints.mobile) {

                    if (!$(this).parents('.slideOutMenu').length) {
                        $(this).removeClass('showSub');
                        $('.sub', this).stop(true, true).fadeOut(300);
                    }
                }
            }
        });
    }
});